import { render, staticRenderFns } from "./EventPointsScheduledToExpire.vue?vue&type=template&id=ca1f723a&scoped=true"
import script from "./EventPointsScheduledToExpire.vue?vue&type=script&scoped=true&lang=js"
export * from "./EventPointsScheduledToExpire.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./EventPointsScheduledToExpire.vue?vue&type=style&index=0&id=ca1f723a&prod&scoped=true&lang=css"
import style1 from "./EventPointsScheduledToExpire.vue?vue&type=style&index=1&id=ca1f723a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca1f723a",
  null
  
)

export default component.exports